import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ExitThisPage } from 'govuk-frontend';

@Component({
  selector: 'aa-exit-button',
  templateUrl: './exit-button.component.html',
  styleUrls: ['./exit-button.component.scss']
})
export class ExitButtonComponent implements AfterViewInit {

  @ViewChild('button') buttonElement: ElementRef | null = null;

  govukExitButton: ExitThisPage | null = null;

  ngAfterViewInit() {
    if(!this.buttonElement) {
      throw new Error("Failed to resolve exit button element");
    }
    this.govukExitButton = new ExitThisPage(this.buttonElement.nativeElement)
  }

    
}
